<template>
  <div class="mdc-layout-grid d-flex flex-column">
    <h3 id="feature7" class="feature mdc-typography--headline3 text-color mb-3">
      F.A.Q
    </h3>
    <p data-scroll class="mdc-typography--body text-color font-weight-bold">
      Întrebări frecvente
    </p>
    <div class="accordion mb-5" id="accordionExample">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {{ $t('faq.q-one') }}
            </button>
          </h5>
          <p>{{ $t('faq.a-one') }}</p>
        </div>

        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            {{ $t('faq.a-one-details') }}
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {{ $t('faq.q-two') }}
            </button>
          </h5>
          <p>
            {{ $t('faq.a-two') }}
          </p>
        </div>
        <div
          id="collapseTwo"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            {{ $t('faq.a-two-details') }}
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              {{ $t('faq.q-three') }}
            </button>
          </h5>
          <p>
            {{ $t('faq.a-three') }}
          </p>
        </div>
        <div
          id="collapseThree"
          class="collapse"
          aria-labelledby="headingThree"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            {{ $t('faq.a-three-details') }}
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingFour">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              {{ $t('faq.q-four') }}
            </button>
          </h5>
          <p>
            {{ $t('faq.a-four') }}
          </p>
        </div>
        <div
          id="collapseFour"
          class="collapse"
          aria-labelledby="headingFour"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            {{ $t('faq.a-four-details') }}
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingFive">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              {{ $t('faq.q-five') }}
            </button>
          </h5>
          <p>
            {{ $t('faq.a-five') }}
          </p>
        </div>
        <div
          id="collapseFive"
          class="collapse"
          aria-labelledby="headingFive"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            {{ $t('faq.a-five-details') }}
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingSix">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              {{ $t('faq.q-six') }}
            </button>
          </h5>
          <p>
            {{ $t('faq.a-six') }}
          </p>
        </div>
        <div
          id="collapseSix"
          class="collapse"
          aria-labelledby="headingSix"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            {{ $t('faq.a-six-details') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq'
}
</script>

<style></style>
